import { actionsFactory, props } from '@ngneat/effects';
import { CompanyEmailSettings, CompanySettings } from '@tmx/data-access';

const appSettingsActions = actionsFactory('app-settings');

export const initializeAppSettings = appSettingsActions.create(
  'Initialize App Settings'
);

export const loadCompanySettings = appSettingsActions.create(
  'Load Company Settings'
);

export const setCompanySettings = appSettingsActions.create(
  'Set Company Settings',
  props<{ companySettings: CompanySettings }>()
);

export const loadPartnerSettings = appSettingsActions.create(
  'Load Partner Settings'
);

export const switchAccountResetAppSettings = appSettingsActions.create(
  'Switch Account Reset App Settings'
);

export const setDataTablePageSize = appSettingsActions.create(
  'Set Data Table Page Size',
  props<{ dataTablePageSize: number }>()
);

export const loadCompanyEmailSettings = appSettingsActions.create(
  'Load Company Email Settings'
);

export const saveCompanyEmailSettings = appSettingsActions.create(
  'Save Company Email Settings',
  props<{ companyEmailSettings: CompanyEmailSettings }>()
);

export const loadCountryCodes = appSettingsActions.create('Load Country Codes');

export const loadLanguages = appSettingsActions.create('Load Languages');

export const loadAccountLanguage = appSettingsActions.create(
  'Load Account Language'
);

export const updateAccountLanguage = appSettingsActions.create(
  'Update Account Language',
  props<{ languageId: string }>()
);

export const setLinkedDataState = appSettingsActions.create(
  'Set Linked Data State'
);

export const loadCompanyLicenseFeatures = appSettingsActions.create(
  'Load Company License Features'
);

export const checkWeatherAlertsEnabled = appSettingsActions.create(
  'Check Weather Alerts Enabled'
);
